import { get_set_record_item_detail } from '@/api/mjstore-model';
import { TableColumn } from '@/typing';
import { slotList } from '@/components/page-model/mjstore/mjstore-setrecord-config';
import double_table_info_modal from '@/components/info-modal/double_table_info_modal';
import { get_is_delete } from '@/utils/function';

export default (current_org: any) => {
  const baseColumns: TableColumn[] = [
    {
      title: '序号',
      dataIndex: 'index',
      width: 50,
      fixed: 'left',
      slots: { customRender: 'index' },
    },
    {
      title: '下套餐日期',
      width: 150,
      dataIndex: 'date',
      checked: true,
      slots: { customRender: 'datetime' },
    },
    {
      title: '创建日期',
      width: 150,
      dataIndex: 'create_time',
      checked: true,
      slots: { customRender: 'datetime' },
    },
    {
      title: '套餐名称',
      width: 175,
      dataIndex: 'project_set__name',
      checked: true,
      slots: { customRender: 'project_set__name' },
    },
    {
      title: '套餐价格',
      width: 75,
      dataIndex: 'price',
      checked: true,
    },
    {
      title: '充值使用金额',
      width: 110,
      dataIndex: 'czje',
      checked: true,
      slots: { customRender: 'round_price' },
    },
    {
      title: '返利使用金额',
      width: 110,
      dataIndex: 'flje',
      checked: true,
      slots: { customRender: 'round_price' },
    },
    {
      title: '直接返利',
      width: 110,
      dataIndex: 'zjfl',
      checked: true,
      slots: { customRender: 'round_price' },
    },
    {
      title: '赠券使用金额',
      width: 110,
      dataIndex: 'zjje',
      checked: true,
      slots: { customRender: 'round_price' },
    },
    {
      title: '促销政策',
      width: 110,
      dataIndex: 'cxzc__name',
      checked: true,
    },
    {
      title: '备注',
      width: 200,
      dataIndex: 'mark',
      checked: true,
    },
    {
      title: '套餐号',
      width: 180,
      dataIndex: 'order_code',
      checked: true,
      slots: { customRender: 'order_code' },
    },
    {
      title: '诉求号',
      width: 170,
      dataIndex: 'require_info__code',
      checked: true,
    },
    {
      title: '所属顾问',
      width: 150,
      dataIndex: 'customer__adviser__name',
      checked: true,
    },
    {
      title: '执行门店',
      width: 150,
      dataIndex: 'shop__name',
      checked: true,
    },
    {
      title: '执行人',
      width: 150,
      dataIndex: 'staff__name',
      checked: true,
    },
    {
      title: '单据状态',
      width: 150,
      dataIndex: 'is_delete',
      checked: true,
      slots: { customRender: 'is_delete' },
      name1: '已作废',
      name2: '未作废',
      color1: 'red',
      color2: 'green',
      filterMultiple: false,
      filters: [
        { text: '未作废', value: false },
        { text: '已作废', value: true },
      ],
      content: (record: any, text: any) => {
        return get_is_delete(text);
      },
    },
    {
      title: '操作',
      width: 200,
      dataIndex: 'action',
      checked: true,
      slots: { customRender: 'action' },
      fixed: 'right',
    },
  ];
  const newSlotList: any = [];
  Object.assign(newSlotList, slotList);
  newSlotList.push({
    type: 'custom',
    slotName: 'is_delete',
    field_true: '已作废',
    field_false: '未作废',
  });
  newSlotList.push(
    { type: 'custom', slotName: 'is_active', field_true: '可用', field_false: '禁用' },
    {
      type: 'click',
      slotName: 'project_set__name',
      cb: (record: any) => {
        console.log('record', record);
        get_set_record_item_detail({ org_id: current_org?.id, set_record_id: record.id }).then(
          (res: any) => {
            const card: any[] = [
              { title: '序号', dataIndex: 'index', width: 100 },
              { title: '卡编号', dataIndex: 'code', width: 200 },
              { title: '卡名称', dataIndex: 'name', width: 200 },
              { title: '项目价格', dataIndex: 'price', width: 150 },
              { title: '项目次数', dataIndex: 'project_set_num', width: 150 },
            ];
            const project: any[] = [
              { title: '序号', dataIndex: 'index', width: 100 },
              { title: '项目编号', dataIndex: 'code', width: 200 },
              { title: '项目名称', dataIndex: 'name', width: 200 },
              { title: '项目价格', dataIndex: 'price', width: 150 },
              { title: '项目次数', dataIndex: 'project_set_num', width: 150 },
            ];

            double_table_info_modal(
              record.project_set__name,
              '卡信息',
              card,
              res.card_item,
              '单信息',
              project,
              res.item,
            );
          },
        );
      },
    },
  );
  return {
    baseColumns: baseColumns,
    newSlotList: newSlotList,
  };
};
